import { render } from "./FlagDE.vue?vue&type=template&id=99704ea8"
import script from "./FlagDE.vue?vue&type=script&lang=js"
export * from "./FlagDE.vue?vue&type=script&lang=js"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__